class NumberUtils {
  getRandomNunber = (limit = 99999) => {
    return Math.floor(Math.random() * limit);
  }
}

export default NumberUtils;
